import React, { useState, useEffect, useCallback } from 'react';
import { Tabs } from '@b-design/fusion';
import $i18n from '@/i18n';
import './index.less';
import Member from './component/member';
import Invitations from './component/invitations';
import Header from './component/header/indexCp';
import store from '@/store';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import CalculateComponent from '@/components/CalculateComponent';

const Members: React.FC = () => {
  // 内容区域高度
  const [contentHeight, setContentHeight] = useState(200);

  const [spaceRoleState] = store.useModel('spaceRole');
  const { spaceId } = getQueryStringArgs();

  // 邀请页面
  const [loading, setLoading] = useState(false);
  // 邀请页面
  const [dataSource, setDataSource] = useState({ list: [], total: 0 });

  // 获取空间邀请列表
  const queryInvitations = useCallback(
    (params = { spaceId, currentPage: 1, pageSize: 10, type: 'APP_DEVELOPER' }) => {
      if (!spaceId) {
        setDataSource({ list: [], total: 0 });

        return;
      }
      setLoading(true);
      Requests.get('/rest/intercnn/invitation/query', { ...params }).then((data) => {
        if (data) {
          const { list = [], total } = data;
          const newList = list?.map(item => ({ ...item, extInfo: { ...item?.extInfo, roleList: item?.extInfo?.role?.split(',') || [] } }))
          setDataSource({ list: newList, total });
          setLoading(false);
        }
      });
    },
    [spaceId],
  );

  return (
    <div className="global-filter-list">
      <Header roleList={spaceRoleState?.roleList} queryInvitations={queryInvitations} />
      <div className="detail-container">
        <Tabs shape="wrapped">
          <Tabs.Item
            title={$i18n.get({ id: 'aopf.pages.member.tabMembers', dm: '成员' })}
            key={'Members'}
          >
            <Member roleList={spaceRoleState?.roleList} contentHeight={contentHeight} />
          </Tabs.Item>
          {spaceRoleState?.roleList?.includes('ADMIN') || spaceRoleState?.roleList?.includes('AIGC_DESIGNER') ? (
            <Tabs.Item
              title={$i18n.get({ id: 'aopf.pages.member.tabInvitations', dm: '邀请' })}
              key={'Invitations'}
            >
              <Invitations
                queryInvitations={queryInvitations}
                loading={loading}
                dataSource={dataSource}
                contentHeight={contentHeight}
              />
            </Tabs.Item>
          ) : null}
        </Tabs>

        <CalculateComponent
          otherWidth={280}
          otherHeight={88 + 48 + 56 + 56}
          windowChange={(_width, height) => {
            setContentHeight(height);
          }}
        />
      </div>
    </div>
  );
};
export default Members;
